module.exports = "/_next/static/images/7b19d516197a713c2f30537f570d22f8-pregnant-woman@tablet@1x.jpg.webp";